module.exports = __webpack_public_path__ + "static/media/heart_empty.66623de4.svg";